import { AlertRisksKeys } from '../../API/types/Alerts';
import { ThemeType } from '../../theme/themeType';

export const generateColorBasedOnRisk = (risk: AlertRisksKeys, theme: ThemeType): string => {
  if (risk === 'low') return theme.colors.badge_risk_low;
  if (risk === 'medium') return theme.colors.badge_risk_medium;
  if (risk === 'urgent') return theme.colors.badge_risk_urgent;

  return theme.colors.inactive;
};

export const capitalizeRiskLevel = (risk: AlertRisksKeys): string => (
  `${risk.charAt(0).toUpperCase() + risk.slice(1)} risk`
);
